import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { BehaviorSubject, forkJoin, map, Observable, switchMap, take } from 'rxjs';
import { PlayerService } from '../player/player.service';
import { SlotsService } from '../slotsservice/slots.service';

@Injectable({
  providedIn: 'root'
})
export class GamesService {
  constructor(private httpClient: HttpClient, private slotService: SlotsService, private playerService: PlayerService) { }

  private _Alljsonfawk = 'assets/fawkGames-1.json';
  private endrophina = 'assets/EndorphinaGames.json';
  private _evigames = 'assets/ezugiEvolutionGames.json';
  private depPayments = 'assets/payments.json';
  private _tableGames = 'assets/tableGames.json';
  private allgames = 'assets/Allgamesite.json'
  private messageSource = new BehaviorSubject<any>(true);
  currentMessage = this.messageSource.asObservable();

  private gamesSubject = new BehaviorSubject<any[]>([]);
  public games$ = this.gamesSubject.asObservable();

  public providerListSubject = new BehaviorSubject<any[]>([]);
  public providerList$ = this.providerListSubject.asObservable();
  changeStatus(message: any) {
    this.messageSource.next(message);
  }


 

  getGamesList(): Observable<any[]> {
    return this.httpClient.get<any[]>(this.allgames);
  }


  getProviderList(loggedin: any) {
    if (loggedin) {
      return this.playerService.onPlayerGetProfile().pipe(
        take(1),
        switchMap((data: any) => {
      const body = {
        role: 0,
        loginName: data.login
      };
      return this.slotService.getpermissionList(body);
        })
      );
    } else {
      return this.slotService.getprovidersbeforelogin();
    }
  }




  fetchAllGames11(data: any) {
    forkJoin({
      games: this.getGamesList(),
      providers: this.getProviderList(data)
    }).subscribe(({ games, providers }) => {
      this.filterGamesByProvider(games, providers, data);
    })
  }

  filterGamesByProvider(games, providers, data): void {
    let enabledProviders:any;
    if (data) {
      enabledProviders = new Set(
        providers
          .filter(p => p.status)
          .map(p => p.name.toLowerCase())
      );
    } else {
      enabledProviders = new Set(
        providers.map(p => p.name.toLowerCase())
      );
    }

    this.providerListSubject.next(enabledProviders)
    let filteredGames = games.filter(game =>
      enabledProviders.has(game?.provider?.toLowerCase())
    ); 
    this.gamesSubject.next(filteredGames)
    const preloader = document.getElementById('preloader');
    if (preloader) {
      setTimeout(() => {
        preloader.style.display = 'none';
      }, 500);
    } 
  } 

  getDepositPayments() {
    return this.httpClient.get<any>(this.depPayments);
  }

  getfawkGames() {
    return this.httpClient.get<any>(this._Alljsonfawk)
  }

  GetendrophinGames() {
    return this.httpClient.get<any>(this.endrophina)
  }
  getevo() {
    return this.httpClient.get<any>(this._evigames);
  }

  getTableGames() {
    return this.httpClient.get<any>(this._tableGames);
  }
  getAllGames() {
    return this.httpClient.get<any>(this.allgames)
  }
}
